import { render, staticRenderFns } from "./replyList.vue?vue&type=template&id=24c43d3d&scoped=true&"
import script from "./replyList.vue?vue&type=script&lang=js&"
export * from "./replyList.vue?vue&type=script&lang=js&"
import style0 from "./replyList.vue?vue&type=style&index=0&id=24c43d3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c43d3d",
  null
  
)

export default component.exports